import {
  styled,
  css,
  Typography,
  AccordionSummary,
  Accordion
} from '@mui/material'

export const AccordionTitle = styled(Typography)(
  () => css`
    font-size: 12px;
    width: 87%;
    flexshrink: 0;
    margin: auto 0;
  `
)

export const AccordionSubtitle = styled(Typography)(
  () => css`
    margin: auto 0;
  `
)

export const AccordionHeader = styled(AccordionSummary)(
  () => css`
    min-height: 54px;
    border-bottom: solid 1px #d7d7d7;
    text-align: left;
  `
)
export const UnspacedAccordion = styled(Accordion)(
  () => css`
    border-radius: 0;
  `
)
